import React from 'react';
import { SVGProps } from '@/components/icon/Icon.types';

export const Remove = ({
  className,
  color = '#00304D',
  width = 24,
  height = 24,
}: SVGProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6568 7.75735L13.4142 12L17.6568 16.2426L16.2426 17.6568L12 13.4142L7.75735 17.6568L6.34314 16.2426L10.5858 12L6.34314 7.75735L7.75735 6.34314L12 10.5858L16.2426 6.34314L17.6568 7.75735Z"
        fill={color}
      />
    </svg>
  );
};
